import { NgModule, ModuleWithProviders } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingGridControllerComponent } from './components/pershing-grid-controller.component';
import { PershingGridColumnComponent } from './components/columns/pershing-grid-columns.component';
import { PershingGridHeaderComponent } from './components/pershing-grid-header.component';
import { PershingNumberFilterComponent } from './components/filters/pershing-number-filter.component';
import { PershingNumberFloatingFilterComponent } from './components/filters/pershing-number-floating-filter.component';
import { PershingTextFilterComponent } from './components/filters/pershing-text-filter.component';
import { PershingTextFloatingFilterComponent } from './components/filters/pershing-text-floating-filter.component';
import { PershingGridInlineMessageComponent } from './components/inline-messages/pershing-grid-inline-message.component';
import { ExportErrorDialog } from './components/pershing-grid-controller.component';
import { GridExportService } from './services/grid-export.service';
import { PershingGridPageNavigatorComponent } from './components/pershing-grid-page-navigator.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

const GRID_COMPONENTS = [
    PershingGridControllerComponent,
    PershingGridColumnComponent,
    PershingGridPageNavigatorComponent,
    PershingGridHeaderComponent,
    PershingNumberFilterComponent,
    PershingNumberFloatingFilterComponent,
    PershingTextFilterComponent,
    PershingTextFloatingFilterComponent,
    PershingGridInlineMessageComponent,
    ExportErrorDialog
];

const PERSHING_GRID_PROVIDERS: any[] = [
    GridExportService
];

@NgModule({
    imports: [
        PershingCoreModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatOptionModule,
        MatSelectModule,
        MatTooltipModule,
        MatSnackBarModule
    ],
    declarations: [
        ...GRID_COMPONENTS
    ],
    exports: [
        ...GRID_COMPONENTS
    ],
    providers: [
        ...PERSHING_GRID_PROVIDERS
    ],
    entryComponents: [
        GRID_COMPONENTS
    ]
})
export class PershingGrid2Module {
    static forRoot(): ModuleWithProviders<PershingGrid2Module> {
        return {
            ngModule: PershingGrid2Module
        };
    }
}
